import { useAvailableTimes } from "api/api-hooks/use-available-times";
import { useReservation } from "api/api-hooks/use-create-reservation";
import { DetailsWithPaymentForm } from "components/details-form/details-with-payment-form";
import { DetailsWithPaymentFormSkeleton } from "components/details-form/details-with-payment-form-skeleton";

const DetailsFormWrapper = () => {
    const { data: reservation } = useReservation();
    const availableTimes = useAvailableTimes(reservation?.start?.clone().startOf("day"));

    if (!reservation?.start) return <DetailsWithPaymentFormSkeleton />;
    if (availableTimes.isPending) return <DetailsWithPaymentFormSkeleton />;

    return <DetailsWithPaymentForm />;
};

export default DetailsFormWrapper;
